<template>
  <div
    class="dashkit"
    style="height: 100%;"
  >
    <div class="checkin-header">
      <h1>
        <img
          class="check-circle"
          src="/image/icon/check-circle.svg"
        >
        <div>
          출석체크 됐습니다.
        </div>
      </h1>
      <div class="checkin-description">
        업데이트된 회원권 정보를 확인하세요.
      </div>
    </div>


    <div class="checkin-action-container">
      <div class="attend-result__form">
        <div class="row">
          <div class="col">
            <div class="attend-result__label">
              이름
            </div>
            <div class="attend-result__content">
              {{ attendanceResult.name }}
            </div>
          </div>
          <div class="col">
            <div class="attend-result__label">
              락커
            </div>
            <div class="attend-result__content">
              {{ attendanceResult.locker ? attendanceResult.locker : '-' }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="attend-result__label">
              회원권
            </div>
            <div class="attend-result__content">
              {{ attendanceResult.membership }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="attend-result__label">
              이용 기간
            </div>
            <div class="attend-result__content">
              {{ presentMembershipPeriod(attendanceResult) }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="attend-result__label">
              최대 이용 가능 {{ membershipSystem.long }}
            </div>
            <div class="attend-result__content">
              {{ presentBalance(attendanceResult.balance) }}
            </div>
          </div>
          <div class="col">
            <div class="attend-result__label">
              이용 {{ membershipSystem.long }}
            </div>
            <div class="attend-result__content">
              {{ presentPoint(attendanceResult.consumed) }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="attend-result__label">
              미수금
            </div>
            <div class="attend-result__content">
              {{ presentRemainder }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="checkin-description bottom-description">
      5초 후 메인페이지로 이동됩니다. <router-link
        to="/checkin"
        replace
      >
        지금 바로 이동 >
      </router-link>
    </div>
    <audio ref="elConfirmAudio">
      <source
        src="//cdn.fiflbox.com/admin/checkin/fiflbox_checkindone.wav"
        type="audio/wav"
      >
    </audio>

    <div class="footer">
      © FIFL Inc.
    </div>
  </div>
</template>

<script>
import dateFns from "date-fns";
import { computedGetters } from "../../utils/vuex-helper";
import { numberWithCommas } from "@/utils/etc";

export default {
	name: "AttendConfirm",
	computed: {
		...computedGetters([
			"attendanceResult",
			"membershipSystem",
			"childMembershipForAttend",
		]),
		presentRemainder() {
			return !this.attendanceResult.remainder
				? "-"
				: numberWithCommas(this.attendanceResult.remainder) + "원";
		},
	},
	created() {
		if (this.childMembershipForAttend.id === null) {
			this.$router.replace("/checkin").catch(()=>{});
		}
	},
	mounted() {
		this.$refs.elConfirmAudio.play();

		setTimeout(() => {
			this.$router.replace("/checkin").catch(()=>{});
		}, 5000);
	},
	methods: {
		presentMembershipPeriod({ start, end }) {
			return `${dateFns.format(start, "YYYY-MM-DD")} -  ${dateFns.format(
				end,
				"YYYY-MM-DD"
			)}`;
		},
		presentBalance(balance) {
			if (balance === -1) {
				return "무제한";
			}

			return balance + this.membershipSystem.short;
		},
		presentPoint(consumed) {
			return consumed + this.membershipSystem.short;
		},
	},
};
</script>

<style lang="scss">
.check-circle {
	width: 40px;
	margin-bottom: 14px;
}

.attend-result__form {
	border-radius: 12px;
	box-shadow: 0 2px 0 0 #d3d3d3;
	border: solid 1.5px #f0f0f0;
	background-color: #ffffff;
	padding: 50px 0;

	.row {
		width: 300px;
		margin: 0 auto 30px;
	}

	.attend-result__label {
		line-height: 24px;
		font-size: 16px;
		font-weight: 300;
		font-style: normal;
		font-stretch: normal;
		letter-spacing: -1px;
		color: #4a4a4a;
		margin-bottom: 8px;
	}

	.attend-result__content {
		line-height: 23px;
		font-size: 19px;
		font-weight: 500;
		font-style: normal;
		font-stretch: normal;
		letter-spacing: -1px;
		color: #4a4a4a;
	}
}

.bottom-description {
	margin-top: 35px;
	text-align: center;

	a {
		color: #9b9b9b;
		text-decoration: underline;

		&:hover {
			color: #9b9b9b;
			text-decoration: underline;
		}
	}

	@media screen and (max-height: 700px) {
		/**
       * Mobile (height < 768px)
       */
		margin-top: 10px;
	}
}

@media screen and (max-height: 1023px) {
	/**
     * Small Desktop or Tablet (768px < height < 1024px)
     */

	.attend-result__form {
		border-radius: 8px;
		padding: 35px 0;

		.row {
			width: 245px;
			margin: 0 auto 20px;
		}

		.attend-result__label {
			font-size: 11px;
			letter-spacing: -0.7px;
			line-height: 17px;
			margin-bottom: 4px;
		}

		.attend-result__content {
			font-size: 13px;
			letter-spacing: -0.7px;
			line-height: 15px;
		}
	}
}

@media screen and (max-height: 700px) {
	/**
     * Mobile (height < 768px)
     */

	.attend-result__form {
		padding: 18px 0;
	}
}
</style>
